import { Grid, Typography } from '@mui/material';
import React from 'react';

export const GridFieldRead = React.memo(({ fields, xs = 4 }) => {
	return (
		<Grid container spacing={2}>
			{fields && (
				<Grid container spacing={2} style={{ padding: '25px' }}>
					{fields.map(({ label, value }, i) => (
						<GridItem
							key={`${label}_${i}`}
							xs={xs}
							title={label}
							text={value}
						/>
					))}
				</Grid>
			)}
		</Grid>
	);
});

export const GridItem = ({ xs, title, text }) => (
	<Grid item xs={xs}>
		<Typography variant='p'>{title}</Typography>
		<Typography variant='h6'>{text}</Typography>
	</Grid>
);
